import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

import { SideMenuContainer } from "../styled/scheduler";
import { createDailyEvent } from "../function/common";

import Calendar from "./sideMenu/calendar";
import Choice from "./sideMenu/choice";
import Actions from "./sideMenu/actions";

export default function SideMenu({
  data,
  sideCalendarRef,
  userDate,
  setUserDate,
  handleDateClick,
  onDate,
  openComponents,
  setOpenComponents,
  setOpenPrint,
}) {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const isDarkMode = useSelector((state) => state?.scheduler?.isDarkMode);

  const [dataByDate, setDataByDate] = useState([]);
  const [version, setVersion] = useState(0);
  const [isAnnualCalendar, setIsAnnualCalendar] = useState(false);

  useEffect(() => {
    const newEvents = createDailyEvent(data);

    setDataByDate(newEvents);
    setVersion((v) => v + 1);
  }, [data]);

  const clickDate = (info) => {
    handleDateClick(info.date);
    setOpenComponents(() => ({ scheduleList: true, sideMenu: false }));
  };

  return (
    <SideMenuContainer
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setOpenComponents((data) => ({ ...data, sideMenu: false }));
        }
      }}
      className={`sidemenu ${isDarkMode}`}
      style={{ transform: `translateX(${isMobile && !openComponents.sideMenu ? "-150%" : "0"})` }}>
      <div className="wrap">
        <Actions onDate={onDate} setOpenPrint={setOpenPrint} />
        <Calendar
          isAnnualCalendar={isAnnualCalendar}
          setIsAnnualCalendar={setIsAnnualCalendar}
          handleDateClick={handleDateClick}
          onDate={onDate}
          userDate={userDate}
          setUserDate={setUserDate}
          data={dataByDate}
          clickDate={clickDate}
          sideCalendarRef={sideCalendarRef}
          version={version}
        />
        <Choice />
      </div>
    </SideMenuContainer>
  );
}
